import formatNumber from './formatNumber';

export const getCurrency = (currency: string) => (currency === 'NOK' ? 'kr' : String(currency)).split('').join('‍');

const formatNumberWithCurrency = (
    number: number | null | undefined,
    currency: string = 'NOK',
    fractals = 2,
    locale = 'nb-NO',
    showLocalCurrency = true,
): string => {
    if (typeof number !== 'number') return '';
    const currencyLabel = currency !== 'NOK' || showLocalCurrency ? ` ${getCurrency(currency)}` : '';
    return `${formatNumber(number, fractals, locale)}${currencyLabel}`;
};

export default formatNumberWithCurrency;
